<template>
  <el-container class="full-height bg-gray">
    <el-main class="page-content">
      <!-- 建议使用 router-view -->
      <router-view/>
    </el-main>
  </el-container>
</template>
<script>
export default {
  data() {
    return {

    }
  }
}
</script>

<style scoped lang="scss">
</style>
